import { ReactNode } from "react";
import { Box, Grid, Typography } from "@mui/material";
import loginImage from "../../assets/images/loginback.png";
import logoLight from "../../assets/images/logo-dark.png";

interface IProps {
  children: ReactNode;
}

const AuthScreenLayout = (props: IProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
      }}
    >
      <Grid container sx={{ height: "100%" }}>
        {/* Left Column */}
        <Grid
          item
          md={7}
          xs={12}
          sx={{
            display: { xs: "none", md: "flex" },
            justifyContent: "center",
            flexDirection: "column",
            background:
              "linear-gradient( 140deg , rgb(5, 117, 230), rgb(2, 27, 121))",
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontWeight: "bold",
              color: "white",
              marginLeft: "150px",
              textShadow: "2px 2px 4px rgba(44, 44, 44, 0.32)",
            }}
          >
            SLT-MOBITEL My Business Portal
          </Typography>
          {/* <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              mb: 2,
              color: "white",
              marginLeft: "150px",
              textShadow: "2px 2px 4px rgba(44, 44, 44, 0.67)",
            }}
          >
            Best Telecommunication Web Portal.........
          </Typography> */}
          <Box
            component="img"
            src={loginImage}
            alt="Login"
            sx={{
              width: "500px",
              maxHeight: "500px",
              position: "absolute",
              bottom: 0,
              left: 0,
            }}
          />
        </Grid>

        {/* Right Column */}
        <Grid
          item
          md={5}
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            px: 3,
            backgroundColor: "white",
          }}
        >
          <Box
            component="img"
            src={logoLight}
            alt="Logo"
            sx={{
              width: "250px",
              height: "auto",
              mb: 4,
            }}
          />
          <Box
            sx={{
              width: "100%",
              maxWidth: "400px",
            }}
          >
            {props.children}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AuthScreenLayout;
